/**
 * Tiny DOM helpers: no framework, no virtual DOM, no dependencies.
 */

type Attrs = Record<string, string | number | boolean | undefined | null>;

export const el = <K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Attrs = {},
  children: Array<Node | string> = [],
): HTMLElementTagNameMap[K] => {
  const element = document.createElement(tag);
  for (const [name, value] of Object.entries(attrs)) {
    if (value === undefined || value === null || value === false) continue;
    if (name === 'class') element.className = String(value);
    else if (name === 'text') element.textContent = String(value);
    else if (name === 'html') element.innerHTML = String(value);
    else if (name.startsWith('data-')) element.setAttribute(name, String(value));
    else if (value === true) element.setAttribute(name, '');
    else element.setAttribute(name, String(value));
  }
  for (const child of children) {
    element.append(typeof child === 'string' ? document.createTextNode(child) : child);
  }
  return element;
};

export const clear = (element: Element): void => {
  element.replaceChildren();
};

export const formatPercent = (value: number | undefined, digits = 1): string =>
  value === undefined || !Number.isFinite(value)
    ? '—'
    : `${(value * 100).toFixed(digits).replace('.', ',')} %`;

export const formatDegrees = (value: number | undefined): string =>
  value === undefined || !Number.isFinite(value)
    ? '—'
    : `${value.toFixed(1).replace('.', ',')}°`;

export const formatMs = (value: number): string => `${Math.round(value)} мс`;

export const VERDICT_LABEL: Record<string, string> = {
  pass: 'Соответствует',
  fail: 'Не соответствует',
  needs_review: 'Требуется проверка',
};

export const STATUS_LABEL: Record<string, string> = {
  pass: 'соответствует',
  fail: 'не соответствует',
  warning: 'замечание',
  uncertain: 'нужна проверка',
  not_checked: 'не проверено',
};

export const STATUS_ICON: Record<string, string> = {
  pass: '✓',
  fail: '✕',
  warning: '!',
  uncertain: '?',
  not_checked: '—',
};

/** Shows an element only when the condition holds (used for optional panels). */
export const toggleHidden = (element: HTMLElement, hidden: boolean): void => {
  element.hidden = hidden;
};
